import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { ILocation } from '../../../../../app/entities/Location'
import PrimaryButton from '../../../global/components/buttons/primary-button/PrimaryButton'
import ScheduleModal from '../schedule-modal/components/container-modal/ScheduleModal'
import styles from './styles.module.css'
import GoogleAddressSearchBar from '../../../global/components/google-address-search/GoogleAddressSearchBar'

interface INewAppointmentProps {
  refetchCalendarEvents: Function
  location: ILocation | undefined
}

export default function NewAppointment({
  refetchCalendarEvents,
  location,
}: INewAppointmentProps) {
  const locationId = location?.objectId ?? ''

  const navigate = useNavigate()
  const [addressInput, setAddressInput] = useState<string>('')
  const [open, setOpen] = useState(false)
  const [isZipCodeServiced, setIsZipCodeServiced] = useState<any>(undefined)

  const [chosenAddress, setChosenAddress] =
    useState<google.maps.GeocoderResult | null>(null)

  const handleOpen = () => {
    navigate('appointment-slots')
    setOpen(true)
  }

  const handleClosed = () => {
    setOpen(false)
    navigate('/')
    refetchCalendarEvents()
  }

  const appointmentButtonCopy = () => {
    if (!chosenAddress) return 'Start typing to select an address'
    if (isZipCodeServiced === undefined) return 'Checking zip code...'
    if (!isZipCodeServiced) return 'Zip code not serviced'
    return 'Start Appointment'
  }

  return (
    <div className={styles.makeAppContainer}>
      <div className={styles.addressSearchBar}>
        <GoogleAddressSearchBar
          addressInput={addressInput}
          setAddressInput={setAddressInput}
          setIsZipCodeServiced={setIsZipCodeServiced}
          location={location}
          setChosenAddress={setChosenAddress}
        />
        <PrimaryButton
          buttonName={appointmentButtonCopy()}
          disabled={!chosenAddress || !isZipCodeServiced}
          onClick={handleOpen}
          style={{ width: '22rem' }}
        />
      </div>
      <ScheduleModal
        isOpen={open}
        handleClosed={handleClosed}
        chosenAddress={chosenAddress}
        locationId={locationId}
      />
    </div>
  )
}
